import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col items-center justify-center py-24" }
const _hoisted_2 = { class: "w-24 h-24 rounded-full bg-[#eafbef] flex items-center justify-center mb-6" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h3", { class: "text-lg font-semibold text-[#16161d] mb-2" }, "Nenhum médico pendente de validação", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-[#7f7f8e] mb-6" }, "Quando houver novas avaliações, elas aparecerão aqui.", -1)

import { mdiCheckCircle } from '@mdi/js'
import GhostButton from '@/components/designSystem/Buttons/GhostButton/index.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'FacialBiometryEmptyState',
  emits: ["clearFilters"],
  setup(__props, { emit }) {



return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_v_icon, {
        size: "48",
        color: "#198038"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(mdiCheckCircle)), 1)
        ]),
        _: 1
      })
    ]),
    _hoisted_3,
    _hoisted_4,
    _createVNode(GhostButton, {
      "data-testid": "clear-filters-button",
      text: "Limpar filtros",
      width: "auto",
      height: "40px",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('clearFilters')))
    })
  ]))
}
}

})